import allCountries from 'iso-3166-country-list';

let blacklist = [
  'AX', 'BQ', 'BV',
  'IO', 'CX', 'CC',
  'CW', 'FK', 'GF',
  'TF', 'HM', 'YT',
  'NU', 'NF', 'MP',
  'PN', 'BL', 'SH',
  'MF', 'PM', 'SX',
  'GS', 'SS', 'SJ',
  'TK', 'UM', 'WF',
];

export default allCountries.filter(country => !blacklist.includes(country.code));



// WEBPACK FOOTER //
// ./lib/rlink-regions/getAllSupportedCountries.js